<template>
  <div id="DistributionFinancialMediaInfluence">
  </div>
</template>

<script>
import resize from '../echarts/mixins/resize'
import * as echarts from 'echarts'
import common from '@/mixins/common.js'
export default {
  mixins: [resize, common],
  name: 'DistributionFinancialMediaInfluence',
  props: [

  ],
  data () {
    let vThat = this
    var seriesLabel = {
      normal: {
        position: ['0%', '-150%'],
        show: true,
        textBorderColor: '#333',
        textBorderWidth: 2,
        color: 'rgba(255,255,255,0.8)'
      }
    }
    return {
      chart: null,
      options: {
        color: ['#0026DA', '#9400D5', '#C80FCB', '#0088FF', '#19F4BF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          triggerOn: 'click'
        },
        legend: {
          data: ['户外大屏', '社区屏', '家用屏', '灯杆屏', '党建屏'],
          icon: 'circle',
          itemWidth: vThat.fontSizeRem(0.4),
          itemHeight: vThat.fontSizeRem(0.4),
          textStyle: {
            color: '#fff',
            fontSize: vThat.fontSizeRem(0.5)
          },
          top: vThat.fontSizeRem(0.4)
        },
        grid: {
          left: '10%',
          top: '15%',
          right: '10%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [{
          type: 'value',
          show: false,
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: false
          }
        }],
        yAxis: [
          {
            type: 'category',
            inverse: true,
            data: ['南山', '西丽', '蛇口', '南头', '粤海', '沙河', '招商', '桃源'], //, '松岗街道', '燕罗街道'
            show: true,
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: vThat.fontSizeRem(0.7)
              }
            },
            axisTick: {
              show: false
            }
          },
          {
            type: 'category',
            inverse: false,
            data: ['30W次', '30W次', '30W次', '60W次', '70W次', '90W次', '90W次', '100W次'], //, '100W次', '120W次'
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: vThat.fontSizeRem(0.7)
              }
            },
            axisTick: {
              show: false
            }
          }],
        series: [
          {
            name: '户外大屏',
            type: 'bar',
            stack: '总量',
            barWidth: vThat.fontSizeRem(0.8),
            label: {
              show: false
            },
            data: [
              36, 33, 39, 28.8,
              31.5, 21, 15, 8.4,
              9, 9.6
            ]
          },
          {
            name: '社区屏',
            type: 'bar',
            stack: '总量',
            label: {
              show: false
            },
            data: [
              12, 7, 10, 10.8,
              13.5, 7, 7.2, 3.9,
              9, 2.7
            ]
          },
          {
            name: '家用屏',
            type: 'bar',
            stack: '总量',
            label: {
              show: false
            },
            data: [
              36, 25, 31, 24.3,
              22.5, 19.6, 15.6, 9,
              2.4, 9.3
            ]
          },
          {
            name: '灯杆屏',
            type: 'bar',
            stack: '总量',
            label: {
              show: false
            },
            data: [
              24, 20, 16, 4.5,
              8.1, 8.1, 4.8, 6,
              8.1, 7.8
            ]
          },
          {
            name: '党建屏',
            type: 'bar',
            stack: '总量',
            label: {
              show: false
            },
            data: [
              12, 15, 4, 24.6,
              14.4, 8.4, 17.4, 2.7,
              7.8, 0.6
            ]
          }
        //   {
        //     name: '南山街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [36, 12, 36, 24, 12]
        //   },
        //   {
        //     name: '西丽街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [33, 7, 25, 20, 15]
        //   },
        //   {
        //     name: '蛇口街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [39, 10, 31, 16, 4]
        //   },
        //   {
        //     name: '南头街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [28.8, 10.8, 24.3, 4.5, 24.6]
        //   },
        //   {
        //     name: '粤海街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [31.5, 13.5, 22.5, 8.1, 14.4]
        //   },
        //   {
        //     name: '沙河街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [21, 7, 19.6, 8.1, 8.4, 14]
        //   },
        //   {
        //     name: '招商街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [15, 7.2, 15.6, 4.8, 17.4]
        //   },
        //   {
        //     name: '桃源街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [8.4, 3.9, 9, 6, 2.7]
        //   },
        //   {
        //     name: '松岗街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [9, 9, 2.4, 8.1, 7.8, 2.7]
        //   },
        //   {
        //     name: '燕罗街道',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //       show: false
        //     },
        //     data: [9.6, 2.7, 9.3, 7.8, 0.6]
        //   }
        ]
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      this.initEchart()
    })
  },
  watch: {

  },
  methods: {
    initEchart () {
      let mapDiv = document.getElementById('DistributionFinancialMediaInfluence')
      // console.log(mapDiv)
      this.chart = echarts.init(mapDiv, {}, { renderer: 'svg' })
      this.chart && this.chart.setOption(this.options)
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
#DistributionFinancialMediaInfluence
  height 14.5rem
</style>
